import { defaultPersistentState } from "./context.js";
import { EProfileAppActions, } from "./types.js";
export const ProfileAppReducer = (prevState, action) => {
    let newState;
    switch (action.type) {
        /* -------------------------------------------------------------------------------------------------
         * App
         * -----------------------------------------------------------------------------------------------*/
        case EProfileAppActions.SET_ERROR_REPORTING:
            newState = {
                ...prevState,
                errorReportingEnabled: action.payload.errorReportingEnabled,
            };
            break;
        case EProfileAppActions.SET_CARDANO_EXPLORER:
            newState = {
                ...prevState,
                cardanoExplorer: action.payload.cardanoExplorer,
            };
            break;
        case EProfileAppActions.SET_ACTIVE_LANGUAGE:
            newState = {
                ...prevState,
                activeLanguage: action.payload.activeLanguage,
            };
            break;
        case EProfileAppActions.LOGOUT:
            return defaultPersistentState;
        default:
            return prevState;
    }
    return newState;
};
//# sourceMappingURL=reducer.js.map